import React, { Fragment, Component } from 'react';
import { hot } from 'react-hot-loader';

import TouchBackend from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
// Data
import storeConnect from 'data/store-connect';
import authStore from 'data/auth';
import { fetchUsers } from 'data/user';
// Routes
import { IRoute } from './routes/utils';
import AuthRoute from './routes/auth-route';
import ROUTES, { getRouteMatch } from './routes';
// Components
import { Route, Switch, withRouter, match as RouterMatch } from 'react-router-dom';
import AppToolbar from './ui/app-toolbar';
import { watchParts } from 'data/part';
import { watchBoards } from 'data/board';
import ItemPreview from './item-preview';

interface MainComponentProps {}

type State = {
  route: IRoute,
  routeMatch: RouterMatch
};
const storeMap = {
  isAuth: () => authStore.isAuthenticated()
};
@withRouter
@storeConnect(storeMap, [authStore])
// @DragDropContext(HTML5Backend)
@DragDropContext(
  TouchBackend({
    enableMouseEvents: true
  })
)
class MainComponent extends Component<MainComponentProps> {
  state: State = {};

  static getDerivedStateFromProps({ location }) {
    if (location) return getRouteMatch(location.pathname);

    return null;
  }

  componentDidMount() {
    const { route, routeMatch } = this.state;

    if (this.props.isAuth) this.init();
    if (route && route.init) route.init(routeMatch.params);
  }

  componentDidUpdate(prevProps) {
    const { route, routeMatch } = this.state;
    const { location } = this.props;

    if (this.props.isAuth) {
      if (!prevProps.isAuth) this.init();
      if (location.pathname !== prevProps.location.pathname && route && route.init) {
        route.init(routeMatch.params);
      }
    }
  }

  init() {
    fetchUsers();
    watchParts();
    watchBoards();
  }

  render() {
    const { route, routeMatch } = this.state;
    return (
      <Fragment>
        <AppToolbar
          hide={route.hideToolbar}
          route={route}
          routeMatch={routeMatch}
          onLink={path => this.props.history.push(path)}
        />
        <Switch>
          {ROUTES.map(route => {
            const Comp = route.noAuth ? Route : AuthRoute;
            return <Comp key={route.path} path={route.path} component={route.component} />;
          })}
        </Switch>

        <ItemPreview key="__preview" name="Item" />
      </Fragment>
    );
  }
}

export default hot(module)(MainComponent);
